var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMailinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0a11 11 0 100 22 11 11 0 000-22zM5.645 7.957A1.668 1.668 0 017.25 6.93h7.48a1.69 1.69 0 011.61.99.299.299 0 01-.158.462l-4.961 2.585a.413.413 0 01-.411 0L5.784 8.36a.262.262 0 01-.139-.403zm10.824 5.696a1.676 1.676 0 01-1.68 1.417H7.244a1.698 1.698 0 01-1.679-1.26 1.725 1.725 0 01-.062-.44V9.776c0-.31.194-.425.473-.282 1.562.813 3.123 1.627 4.682 2.442a.68.68 0 00.693 0c1.552-.814 3.106-1.62 4.662-2.42a.537.537 0 01.14-.057.262.262 0 01.346.28v3.108a4.89 4.89 0 01-.03.805z",
    fill: "#3FC07F"
  })));
}

export default SvgMailinline;